import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/* New routes start at top; hash links (e.g. /#quote) scroll to their section,
   retrying so positions settle after the Home hero pin spacer is created. */
export default function ScrollManager() {
  const { hash, key } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      let tries = 0;
      let timer = 0;
      const go = () => {
        const el = document.getElementById(id);
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72 });
        tries += 1;
        if (tries < 4) timer = window.setTimeout(go, 300);
      };
      timer = window.setTimeout(go, 60);
      return () => window.clearTimeout(timer);
    }
    // 'instant' overrides the global CSS smooth scrolling, so new pages open at the top without a visible scroll-up.
    if (navType !== 'POP') window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    return undefined;
  }, [key, hash, navType]);

  return null;
}